// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.status-item {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.status-item strong {
  display: block;
  margin-bottom: 5px;
  color: #495057;
}

.badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.record-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.stat-item {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  background-color: #e9ecef;
  border-radius: 3px;
  font-size: 12px;
}

.stat-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  color: #6c757d;
}

.stat-icon.error {
  color: #dc3545;
}

.error-message {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #dc3545;
  font-size: 12px;
}

.error-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
}

.alert {
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.card-body {
  padding: 20px;
}

table {
  margin-top: 15px;
}

th {
  font-weight: 600;
  background-color: #f8f9fa;
}

td, th {
  padding: 12px 16px;
}

tr:hover {
  background-color: #f8f9fa;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
}

.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}

.mb-20 {
  margin-bottom: 20px;
}

.muted {
  color: #666;
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}

.icon-16 {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: text-bottom;
  margin-right: 4px;
}

.orion-result-text {
  flex: 1;
}

.orion-http-code {
  font-family: monospace;
  font-size: 12px;
}

.orion-hint-list {
  margin: 6px 0 0;
  padding-left: 20px;
}
.orion-hint-list code {
  font-size: 12px;
  padding: 1px 4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.08);
}

.orion-json-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.orion-json-header h5 {
  margin: 0;
}

.orion-json-pre {
  margin: 0;
  padding: 16px;
  background-color: #1e1e1e;
  color: #d4d4d4;
  font-size: 12px;
  max-height: 450px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/cmdb-sync/cmdb-sync.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,wCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;AACJ;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAEE;EACE,SAAA;AAAJ;;AAIA;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AADF","sourcesContent":[".status-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.status-item {\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.status-item strong {\n  display: block;\n  margin-bottom: 5px;\n  color: #495057;\n}\n\n.badge {\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.record-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.stat-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  background-color: #e9ecef;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n.stat-icon {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n  color: #6c757d;\n}\n\n.stat-icon.error {\n  color: #dc3545;\n}\n\n.error-message {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #dc3545;\n  font-size: 12px;\n}\n\n.error-icon {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n}\n\n.alert {\n  padding: 12px 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.alert-success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.card {\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.card-body {\n  padding: 20px;\n}\n\ntable {\n  margin-top: 15px;\n}\n\nth {\n  font-weight: 600;\n  background-color: #f8f9fa;\n}\n\ntd, th {\n  padding: 12px 16px;\n}\n\ntr:hover {\n  background-color: #f8f9fa;\n}\n\n.alert-warning {\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  color: #856404;\n}\n\n.alert-info {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  color: #0c5460;\n}\n\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.muted {\n  color: #666;\n}\n\n.field-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.icon-16 {\n  font-size: 16px;\n  height: 16px;\n  width: 16px;\n  vertical-align: text-bottom;\n  margin-right: 4px;\n}\n\n.orion-result-text {\n  flex: 1;\n}\n\n.orion-http-code {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.orion-hint-list {\n  margin: 6px 0 0;\n  padding-left: 20px;\n\n  code {\n    font-size: 12px;\n    padding: 1px 4px;\n    border-radius: 3px;\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n}\n\n.orion-json-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n\n  h5 {\n    margin: 0;\n  }\n}\n\n.orion-json-pre {\n  margin: 0;\n  padding: 16px;\n  background-color: #1e1e1e;\n  color: #d4d4d4;\n  font-size: 12px;\n  max-height: 450px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
